/**
 * TopMags' cancellation and refund terms, in one place because this brand publishes them
 * in two: `/refund` is these words and nothing else, and they are the FAQ's last
 * answer.
 *
 * The words were this brand's own `includes/modules/legal/refund.html` — not the
 * `returns.html` MagSpot and MagZoom published — written out here rather than included as
 * a document, which is how DiscountMags' refund page already works. That module rendered
 * only in the checkout lightbox, and the checkout agreement links to `/refund`
 * instead now, so it is gone and these words live here alone.
 *
 * The second sentence read "you do not which to keep" in that module, and had done since
 * it was written. It is correct here.
 *
 * Not a card and not a heading: it is the terms alone, so either caller can frame them the
 * way its own page frames things.
 */
export default function RefundTerms() {
  return (
    <>
      <p>
        Within 6 months of your order date, you may request to cancel and receive a pro-rated refund
        for any undelivered issues.
      </p>

      <p>
        In the event that a magazine ceases publication, the industry practice is to provide a
        substitute publication similar to the magazine that ceased publication. In this instance, a
        refund will not be provided unless it is within 6 months of the order date and you do not
        wish to keep the substitute publication.
      </p>
    </>
  );
}
